import * as firebase from 'firebase/app'
import _ from 'lodash'
import {tryCall,safeComputeInteger} from "../utils";
import runtime, { isOfflineEnv } from "../utils/runtime";
import { checkCompat } from '../compatibility';
import { transport } from '../transport';
import { FIREBASE_ENDPOINT_NAME, PROMETHEUS_ENDPOINT_NAME } from '../constants';
import { getUrl } from '../utils/path';


// 管理 firebase 统计渠道的网络性能
export function init() {
  tryCall(() => reportNetworkNavigation(), false)
}

// 借由统计首个doc的加载性能，量化用户的网络性能
// 不统计前进后退等可能直接加载本地缓存的场景
function reportNetworkNavigation() {
  // 加载行为检查，确保是加载或刷新
  if (performance.navigation.type !== 0 && performance.navigation.type !== 1) {
    // https://developer.mozilla.org/zh-CN/docs/Web/API/PerformanceNavigation
    return false
  }

  const navigationEntry = tryCall(() => performance.getEntriesByType('navigation')[0])
  const metrics = parseTimingObjectToNetwork(performance.timing)
  const n = isOfflineEnv() ? 'off_network_navigation' : 'network_navigation';

  transport({
    endPoints: [FIREBASE_ENDPOINT_NAME, PROMETHEUS_ENDPOINT_NAME],
    type: n,
    traceName: n,
    url: getUrl(),
    message: {
      metrics: {
        duration: metrics.total_wait,
        ..._.pickBy({
          ..._.omit(metrics, 'total_wait'),
          transfer_size: safeComputeInteger(() => navigationEntry && (navigationEntry.transferSize / 1024))
        }, _.isFinite)
      },
      attributes: {
        navigation_type: performance.navigation.type + '',
        pathname: location.pathname,
        protocol: (navigationEntry && navigationEntry.nextHopProtocol) || '',
        is_https: location.protocol === 'https' ? ' true' : 'false',
        no_download: metrics.download === 0 ? 'true' : 'false'
      },
    },
  });

  // 标记统计成功
  return true
}

// API定义  https://developer.mozilla.org/zh-CN/docs/Web/API/PerformanceTiming
// 基本原理  https://blog.51cto.com/shuizhongyue/1718327
// 各字段完整描述见  https://www.cnblogs.com/btgyoyo/p/6341077.html
function parseTimingObjectToNetwork(timingObject) {
  const metrics = {}
  // 总等待时长
  metrics.total_wait = safeComputeInteger(() => timingObject.responseEnd - timingObject.navigationStart)
  // 等待重定向时间。未重定向时为0
  metrics.redirect = safeComputeInteger(() => timingObject.redirectEnd - timingObject.redirectStart)
  // DNS查询。本地复用缓存时为0
  metrics.dns = safeComputeInteger(() => timingObject.domainLookupEnd - timingObject.domainLookupStart)
  // TCP连接和SSL连接
  if (timingObject.secureConnectionStart === 0) {
    metrics.tcp = safeComputeInteger(() => timingObject.connectEnd - timingObject.connectStart)
    metrics.ssl = 0
  } else {
    metrics.tcp = safeComputeInteger(() => timingObject.secureConnectionStart - timingObject.connectStart)
    metrics.ssl = safeComputeInteger(() => timingObject.connectEnd - timingObject.secureConnectionStart)
  }
  // TTFB
  metrics.ttfb = safeComputeInteger(() => timingObject.responseStart - timingObject.requestStart)
  // 响应时间，TTFB至内容下载完成
  metrics.download = safeComputeInteger(() => timingObject.responseEnd - timingObject.responseStart)
  // 总网络消耗时间（redirect之后，至请求结束），不含 redirect/dom 处理时间
  metrics.pure_network = safeComputeInteger(() => timingObject.responseEnd - timingObject.fetchStart)
  // 返回
  return metrics
}



